module.exports = __webpack_public_path__ + "static/media/technician.3637e296.png";